import { Flex, PrimaryButton, useSafeArea } from '@banhala/ui-kit';

interface FolderShareButtonProps {
  isEnabled: boolean;
  onPressShare: () => void;
}

export const FolderShareButton = ({
  isEnabled,
  onPressShare,
}: FolderShareButtonProps) => {
  const insets = useSafeArea();
  return (
    <Flex
      backgroundColor={'content_always_white'}
      borderTopWidth={1}
      borderColor={'border_transparent'}
    >
      <Flex.Row
        padding={{
          horizontal: 12,
          top: 12,
          bottom: insets.bottom + 12,
        }}
      >
        <Flex flex={1}>
          <PrimaryButton
            variant={'fill'}
            outline
            color={'gray'}
            size={'xlarge'}
            state={isEnabled ? undefined : 'disabled'}
            onPress={onPressShare}
          >
            내 서랍 공유
          </PrimaryButton>
        </Flex>
      </Flex.Row>
    </Flex>
  );
};
